import { objectToCamelCase } from '../utils'

import SelectOrganizationAPI from './api'

const DEFAULT_DARK_BRAND_COLOR = '2e63b3'
const DEFAULT_LIGHT_BRAND_COLOR = 'cce2f5'

export default class SelectOrganization {
  static api = SelectOrganizationAPI.create(SelectOrganization)

  constructor(json) {
    Object.assign(this, { ...json })
    this.darkBrandColor = this.darkBrandColor || DEFAULT_DARK_BRAND_COLOR
    this.lightBrandColor = this.lightBrandColor || DEFAULT_LIGHT_BRAND_COLOR
    this.grantLimitDuration = this.formatGrantLimitDuration(
      this.grantLimitDuration,
      this.rollingGrantDuration,
    )
  }
  static create(opts) {
    return new SelectOrganization(opts)
  }

  static fromAPI(json) {
    return new SelectOrganization(objectToCamelCase(json))
  }

  formatGrantLimitDuration(duration, rollingGrantDuration) {
    const lookup = {
      CALENDAR_YEAR: 'Calendar Year',
      LIFETIME: 'Lifetime',
      ROLLING_X_YEARS: `Rolling ${rollingGrantDuration} Years`,
    }
    return lookup[duration]
  }
}
